/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteComponentProps } from 'react-router-dom';

import { CurrencyContext } from '@tock/coretypes';
import { DisplayMoney } from '@tock/money';
import { StoreType } from '@tock/shared/utils/connect';
import BaseComponent from '@tock/shared/components/BaseComponent';
import SectionHeader from 'components/SectionHeader';
import TransferPriceForm from 'forms/transfer/TransferPriceForm';
import uiFlowComponent, { FlowProps } from 'components/ui-flow/uiFlowComponent';

export interface Props extends RouteComponentProps {
  onSetTransferPrice(price: number): void;
  transfer: StoreType['transfer'];
}

class TransferPriceRoute extends BaseComponent<Props & FlowProps> {
  handleSubmit(data: { price: number }) {
    this.props.onSetTransferPrice(data.price);
    this.props.history.push(this.props.nextRoute);
  }

  getTransferText(transfer: any) {
    const preMoneyDisplayText = 'You were charged ';
    const postMoneyDisplayText =
      ` for this reservation. Please choose the price ${transfer.transferToEmail} will pay (up to the amount paid). ` +
      'This amount will be refunded to the card used in the original purchase. Please note, pricing for this booking is subject to change from the original price paid.';
    const moneyText = (
      <CurrencyContext.Provider value={transfer.purchase.business.currencyCode} key={1}>
        <DisplayMoney amount={transfer.purchase.amountPaidCents} />
      </CurrencyContext.Provider>
    );
    return [preMoneyDisplayText, moneyText, postMoneyDisplayText];
  }

  render() {
    const { transfer } = this.props;
    const subheading = this.getTransferText(transfer);

    return (
      <div className="MainContent">
        <div className="SectionWrapper">
          <div className="SectionContent">
            <SectionHeader heading="Name your price" subheading={subheading} />
            <TransferPriceForm
              amountPaidCents={transfer.purchase.amountPaidCents ?? undefined}
              currency={transfer.purchase.business?.currencyCode ?? undefined}
              purchasePriceCents={transfer.purchase.amountPaidCents ?? undefined}
              onSubmit={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default uiFlowComponent(TransferPriceRoute);
